import axios from "axios";
import NProgress from "nprogress";


const apiClient = axios.create({
  baseUrl: "http://localhost:3000",
  withCredentials: false,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

const apiClientDelete = axios.create({
  baseUrl: "http://localhost:3000",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

const url = "https://www.wohnungsdatenbank.uni-freiburg.de/backend/Angebote/";

export default {
  addImages(formData){
    return apiClient.post(url+ "handleImages.php",
      formData,
      {
        headers: {'Content-Type': 'multipart/form-data' }
      }
    );
  },
  deleteImages(id){
    return apiClientDelete.get(url + "deleteImages.php",{
          params:{
            angebotID: id,
          }
        }
    );
  },
    deleteSingleImage(name){
        return apiClientDelete.get(url + "deleteSingleImage.php",{
                params:{
                    name: name,
                }
            }
        );
    },
  getImages(id){
    return apiClientDelete.get(url + "getImages.php",{
          params:{
            angebotID: id,
          }
        }
    );
  },
};
